import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { termsAndConditionsAPI } from '../../services/api';

interface TermsState {
  content: string;
  loading: boolean;
  error: string | null;
  saved: boolean;
}

const initialState: TermsState = {
  content: '',
  loading: false,
  error: null,
  saved: false,
};

export const fetchTerms = createAsyncThunk(
  'terms/fetchTerms',
  async () => {
    const response = await termsAndConditionsAPI.getTerms();
    return response.data.text;
  }
);

export const saveTerms = createAsyncThunk(
  'terms/saveTerms',
  async (content: string) => {
    const response = await termsAndConditionsAPI.updateTerms(content);
    return response.data.text;
  }
);

const termsSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
    },
    clearSaved: (state) => {
      state.saved = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTerms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTerms.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
      })
      .addCase(fetchTerms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch terms';
      })
      .addCase(saveTerms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveTerms.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
        state.saved = true;
      })
      .addCase(saveTerms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to save terms';
      });
  },
});

export const { setContent, clearSaved, clearError } = termsSlice.actions;
export default termsSlice.reducer;